<fieldset [disabled]="disabled">
    <div (click)="toggleValue()" class="d-flex align-items-center">
        <ui-switch [ngModel]="value"></ui-switch>
        <span class="ml-2" style="cursor: pointer; font-weight: 600">
            <ng-content></ng-content>
        </span>
    </div>
</fieldset>
